var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEye(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19.057,
    height: 11.915,
    viewBox: "0 0 19.057 11.915",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "eye",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7137",
    "data-name": "Path 7137",
    d: "M9.529,98.725c-3.641,0-6.943,2.089-9.379,5.483a.822.822,0,0,0,0,.945c2.436,3.4,5.738,5.487,9.379,5.487s6.943-2.089,9.379-5.483a.822.822,0,0,0,0-.945C16.472,100.814,13.17,98.725,9.529,98.725Zm.261,10.153a4.208,4.208,0,0,1-.522-8.39,4.208,4.208,0,0,1,.522,8.39Zm-.121-1.938a2.266,2.266,0,1,1,2.015-2.114A2.222,2.222,0,0,1,9.669,106.939Z",
    transform: "translate(0 -98.725)",
    fill: "#d9d9d9"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEye);
export default __webpack_public_path__ + "static/media/eye.94412c22efe769f650fdd4ee3ab208ef.svg";
export { ForwardRef as ReactComponent };